







export default {
  name: "BaseToggleSwitch",
  props: {
    value: {
      type: Boolean,
    },
  },
  computed: {
    checkboxValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {},
};
